var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewQapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96.4 121.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.2,0c29.1,31.1,48.2,44.5,48.2,73c0,28.5-16.3,48.9-48.2,48.9S0,101.5,0,73C0,44.5,29.4,20.7,48.2,0L48.2,0 z M48.2,35.2c23.7,0,36,14.6,36,38.3c0,8.9-1.7,16.6-5.2,22.6l2.7,2.7c1.8,1.8,1.8,4.9,0,6.8l-2.7,2.7c-1.9,1.9-4.9,1.9-6.8,0 L70,106c-5.6,3.8-12.9,5.8-21.8,5.8c-23.7,0-36-14.6-36-38.4C12.2,49.8,24.5,35.2,48.2,35.2L48.2,35.2z M60.4,89.7l2.7-2.7 c1.9-1.8,4.9-1.8,6.8,0l0.2,0.2c1.8-3.8,2.6-8.4,2.6-13.6c0-16.1-8.4-26.1-24.5-26.1c-16.2,0-24.5,9.9-24.5,26.1 c0,16.2,8.4,26.1,24.5,26.1c5,0,9.2-1,12.6-2.7l-0.4-0.5C58.5,94.6,58.5,91.5,60.4,89.7L60.4,89.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewQapp);
export default __webpack_public_path__ + "static/media/new-qapp.602eedf31da5b4126e88601d3aee9c86.svg";
export { ForwardRef as ReactComponent };